import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const CHART_COLORS = {
  reservations: "#18344A",
  revenue: "#526E7E",
  inquiries: "#B7A58E",
  signups: "#78909C",
};

export const PIE_COLORS = ["#18344A", "#526E7E", "#B7A58E", "#78909C", "#9fb0b8"];

export function ChartCard({ title, action, children, testId, className = "" }) {
  return (
    <Card
      data-testid={testId}
      className={`rounded-[14px] border-[var(--pb-border)] bg-white shadow-[var(--pb-shadow-sm)] ${className}`}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="font-display text-base font-semibold text-[#18344A]">{title}</CardTitle>
        {action}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}

export function ChartTooltip({ active, payload, label, valueFormatter }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-[10px] border border-[var(--pb-border)] bg-white px-3 py-2 shadow-[var(--pb-shadow-md)]">
      {label && <div className="mb-1 text-xs font-medium text-[#30383C]">{label}</div>}
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-2 text-xs">
          <span className="h-2 w-2 rounded-full" style={{ background: p.color || p.fill }} />
          <span className="text-[rgba(48,56,60,0.7)]">{p.name}:</span>
          <span className="font-num font-medium text-[#30383C]">
            {valueFormatter ? valueFormatter(p.value, p.dataKey) : p.value}
          </span>
        </div>
      ))}
    </div>
  );
}
